import React from "react";
import "./Header.css";
import { SocialIcon } from "react-social-icons";

class Header extends React.Component{
    render(){
        return (
            <div className="Header">
                <div className="social-media">
                    <SocialIcon url="mailto:bayleysapara@gmail.com" bgColor="dimgray"
                    
                    />
                    <SocialIcon url="https://www.linkedin.com/in/bayley-sapara-181170224/" bgColor="dimgray"
                    
                    />
                    <SocialIcon url="https://github.com/Eluviian" bgColor="dimgray"
                    
                    />
                    
                </div>
                <div className="text">Hello World</div>
                
                
            </div>
        )
    }
}

export default Header;